import { paths } from "src/routes/paths";

import Iconify from "src/components/iconify";

// ----------------------------------------------------------------------
const width = 16;
export const playerNavConfig = [
  {
    title: "playermenu_overview",
    path: paths.player.overview,
    icon: <Iconify icon="grommet-icons:overview" width={width} />,
    playermenudisplay: 1,
    playertabsdisplay: 1,
  },
  {
    title: "playermenu_myapplications",
    path: paths.player.activities,
    icon: <Iconify icon="fluent-mdl2:reservation-orders" width={width} />,
    playermenudisplay: 1,
    playertabsdisplay: 1,
  },
  {
    title: "menu_sportmates",
    path: paths.sportmates.root,
    icon: <Iconify icon="fluent-mdl2:reservation-orders" width={width} />,
    playermenudisplay: 1,
    playertabsdisplay: 0,
  },
  {
    title: "playermenu_passestickets",
    path: paths.player.passestickets,
    icon: <Iconify icon="fluent-mdl2:reservation-orders" width={width} />,
    playermenudisplay: 1,
    playertabsdisplay: 1,
  },
  {
    title: "playermenu_messages",
    path: paths.player.messages,
    icon: <Iconify icon="tabler:message" width={width} />,
    playermenudisplay: 1,
    playertabsdisplay: 1,
  },
  {
    title: "playermenu_teams",
    path: paths.player.teams,
    icon: <Iconify icon="ic:baseline-sports" width={width} />,
    playermenudisplay: 1,
    playertabsdisplay: 1,
  },
  {
    title: "playermenu_providers",
    path: paths.player.providers,
    icon: <Iconify icon="ic:baseline-sports" width={width} />,
    playermenudisplay: 1,
    playertabsdisplay: 1,
  },
  {
    title: "playermenu_profiledata",
    path: paths.player.profiledata,
    icon: <Iconify icon="mdi:settings-outline" width={width} />,
    playermenudisplay: 1,
    playertabsdisplay: 1,
  },
];
